var $adf27e08d69e9ace$exports = {};
$adf27e08d69e9ace$exports = {
    "valid": `Galioja`
};


export {$adf27e08d69e9ace$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
